<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
	<g>
		<path
			d="M2.61 24a2.113 2.113 0 0 0 2.109-2.11c0-.913-.59-1.687-1.407-1.977v-1.538h4.22v1.538a2.11 2.11 0 0 0-1.407 1.978c0 1.162.947 2.109 2.11 2.109s2.109-.947 2.109-2.11c0-.913-.59-1.687-1.406-1.977v-2.944H6.124v-1.407h12.75v1.407h-2.812v2.944a2.11 2.11 0 0 0-1.407 1.978c0 1.162.947 2.109 2.11 2.109s2.109-.947 2.109-2.11c0-.913-.59-1.687-1.406-1.977v-1.538h4.218v1.538a2.11 2.11 0 0 0-1.406 1.978c0 1.162.947 2.109 2.11 2.109s2.109-.947 2.109-2.11c0-.913-.59-1.687-1.406-1.977v-2.944H20.28v-2.813H4.72v2.813H1.906v2.944A2.11 2.11 0 0 0 .5 21.89c0 1.163.947 2.11 2.11 2.11M8.984 5.016c0 1.298.708 2.484 1.852 3.098.586.314.96 1.008.96 1.767v1.463h-1.405v1.406h4.218v-1.406h-1.406V9.88c0-.76.375-1.453.961-1.767a3.51 3.51 0 0 0 1.852-3.098V2.813h1.406V1.406h-1.406V0H8.984v1.406H7.578v1.407h1.406z"
		/>
	</g>
</svg>
